module.exports = __webpack_public_path__ + "b.no1.ebfe07aa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/b.no1.jpg
// module id = 2z0I
// module chunks = 0